import { AxiosError } from 'axios';
import { useMutation, useQuery } from 'react-query';
import { RemotePHSEventRepo } from '@repository/phs/event/PHSEventRepo';
import PhsEventApplyRq from '@domain/rq/phs/event/PhsEventApplyRq';
import PHSApplyRs from '@domain/rs/phs/apply/PhsApplyRs';

const remotePHSEventRepo = new RemotePHSEventRepo();

const keys = ['phs', 'event'];
const applyStatusKeys = [...keys, 'applyStatus'];
const positionApplicationsKeys = [...keys, 'position', 'applyStatus'];

const fetchPHSEventApply = async (rq: PhsEventApplyRq) => {
  const { data } = await remotePHSEventRepo.fetchPHSEventApply(rq);
  return data;
};

const fetchPHSApplyStatus = async () => {
  const { data } = await remotePHSEventRepo.fetchPHSApplyStatus();
  return data;
};

const fetchPositionApplicationStatus = async () => {
  const { data } = await remotePHSEventRepo.fetchPositionApplicationStatus();
  return data;
};

function usePHSEventApply(onSuccess: (data: PHSApplyRs) => void, onError: (err: AxiosError) => void) {
  return useMutation((rq: PhsEventApplyRq) => fetchPHSEventApply(rq), {
    onSuccess,
    onError,
  });
}

function usePHSEventApplyStatus(enabled: boolean) {
  return useQuery(applyStatusKeys, fetchPHSApplyStatus, {
    enabled,
    refetchOnWindowFocus: true,
  });
}

function usePositionApplicationStatus(enabled: boolean) {
  return useQuery(positionApplicationsKeys, fetchPositionApplicationStatus, {
    enabled,
    refetchOnWindowFocus: true,
  });
}

export {
  keys as phsEventKeys,
  applyStatusKeys as phsEventApplyStatusKeys,
  positionApplicationsKeys as phsEventPositionApplicationsKeys,
  usePHSEventApply,
  usePHSEventApplyStatus,
  usePositionApplicationStatus,
};
